import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { connect } from "react-redux";
import { Typography, Link } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  body: {
    width: "95%",
    margin: "auto",
    marginTop: "10%",
    textAlign: "center"
  },
  color: {
    color: theme.colorScheme
  },
  title: {
    fontSize: 100
  },
  caption: {
    fontSize: 20,
    paddingBottom: 50
  },
  link: {
    paddingTop: 50
  },
  darkModeText: {
    color: theme.palette.text.primary
  }
}));

const Page404 = props => {
  const [homepage, setHomepage] = useState(null);
  const classes = useStyles();

  useEffect(() => {
    if (props.user) {
      if (props.user.user_type === "Tenant User") {
        setHomepage(process.env.PUBLIC_URL + "/dashboard");
      } else if (props.user.user_type === "Company Employee" && props.user.role?.status) {
        setHomepage(process.env.PUBLIC_URL + "/portal/credentials");
      }else if (props.user.user_type === "Reseller User") {
        setHomepage(process.env.PUBLIC_URL + "/reseller/dashboard");
      }else if (props.user.user_type === "Super User") {
        setHomepage(process.env.PUBLIC_URL + "/admin/dashboard");
      }
      else{
        if (props.user.user_type === "Company Employee") setHomepage(process.env.PUBLIC_URL + "/portal/login")
        else setHomepage(process.env.PUBLIC_URL + "/login");
      }
    } else {
      // If no user, default to login page
      setHomepage(process.env.PUBLIC_URL + "/login");
    }
  }, [props.user]);

  return (
    <div className={classes.root}>
      <Grid container className={classes.body}>
        <Grid item xs={12}>
          <Typography
            variant="h1"
            className={`${classes.color} ${classes.title}`}
          >
            404
          </Typography>
        </Grid>
        <Grid item xs={12} md={12}>
          <Typography variant="h5" className={classes.darkModeText}>OOPS! NOTHING WAS FOUND</Typography>
        </Grid>
        <Grid item xs={12} md={12}>
          <Typography variant="h5" className={`${classes.caption} ${classes.darkModeText}`}>
            The page you are looking for might have been removed, had its name
            changed or is temporarily unavailable.
          </Typography>
        </Grid>
        <Grid item xs={12} md={12}>
          <Typography variant="h5" className={classes.caption}>
            <Link
              className={`${classes.color} ${classes.link}`}
              href={homepage || (process.env.PUBLIC_URL + "/login")}
            >
              Return to homepage
            </Link>
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    user: state.user.user
  };
};

export default connect(mapStateToProps, null)(Page404);